
/**
 * Chart
 */
function irChart() {
	if (!document.getElementById('notowania-iframe')) return;

	window.addEventListener("message", function(event) {
		if (event.data.iframeHeight) {
			const iframe = document.getElementById("notowania-iframe");
			if (iframe) {
				iframe.style.height = event.data.iframeHeight + "px";
			}
		}
	});
}